import Dashboard from "pages/dashboard";
import CategoryManagement from "pages/category-management/CategoryManagement";
import SubCategoryManagement from "pages/subCategoryManagement/SubCategoryManagement";
import BrandManagement from "pages/Brand-Management/BrandManagement";
import BannerManagement from "pages/Banner-management/BannerManagement";
import PrescriptionManagement from "pages/prescription-management/PrescriptionManagement";
import ProductManagement from "pages/Product-Management/ProductManagement";
import UserManagement from "pages/user-management/UserManagement";
import UserManagementDetails from "pages/user-management/UserManagementDetails";
import PrescriptionDetails from "pages/prescription-management/PrescriptionDetails";
import AddNewProduct from "pages/Product-Management/ProductComponent/AddNewProduct";
import EditSelectedProduct from "pages/Product-Management/ProductComponent/EditSelectedProduct";
import EditUserManagement from "pages/user-management/EditUserManagement";
import ManageDelivery from "pages/manageDeliverySlots/ManageDelivery";
import CoinManagement from "pages/coinManagement/CoinManagement";
import PromoCodeManagement from "pages/promocode/PromocodeManagement";
import AddPromoCode from "pages/promocode/section/AddPromoCode";
import ContentManagement from "pages/content-management/ContentManagement";
import NotificationList from "pages/notifications/NotificationList";
import CreateNotification from "pages/notifications/CreateNotification";
import OrderManagement from "pages/oderManagement/OrderManagement";
import OrderDetails from "pages/oderManagement/view/OrderDetails";
import TransactionList from "pages/transactionManagement/TransactionList";
import SubAdminList from "pages/subAminManagement/SubAdminList";
import SupportList from "pages/CustomerSupport/SupportList";
import OfferList from "pages/offerManagement/OfferList";
import AddOffer from "pages/offerManagement/section/AddOffer";
import UpdateOffer from "pages/offerManagement/section/UpdateOffer";
import List from "pages/outOfStock/List";
import SubSubCategoryList from "pages/subSubCategory/SubSubCategoryList";
import PaymentList from "pages/paymentManagement/PaymentList";
import HighStock from "pages/highStock/highStock";
import UpdatePromoCode from "pages/promocode/section/UpdatePromoCode";
import ViewSelectedProduct from "pages/Product-Management/ProductComponent/ViewSelectedProduct";
import AddSubCat from "pages/subCategoryManagement/AddSubCat";
import EditSubCat from "pages/subCategoryManagement/EditSubCat";

// import verifyOtpHandler from 'pages/auth/'

export const routes = () => {
  const allRoutes = [
    // Dashboard
    {
      id: 101,
      enabled: true,
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      id: 102,
      enabled: true,
      path: "/category-management",
      element: <CategoryManagement />,
    },
    {
      id: 103,
      enabled: true,
      path: "/sub-Category-Management",
      element: <SubCategoryManagement />,
    },
    {
      id: 4303,
      enabled: true,
      path: "/sub-sub-Category",
      element: <SubSubCategoryList />,
    },
    {
      id: 104,
      enabled: true,
      path: "/brand-management",
      element: <BrandManagement />,
    },
    {
      id: 105,
      enabled: true,
      path: "/banner-management",
      element: <BannerManagement />,
    },
    // -------------------prescription management
    {
      id: 106,
      enabled: true,
      path: "/prescription-management",
      element: <PrescriptionManagement />,
    },

    {
      id: 107,
      enabled: true,
      path: "/prescription-management/userDetail/:userId",
      element: <PrescriptionDetails />,
    },
    // ------------ /product-management part starts
    {
      id: 108,
      enabled: true,
      path: "/product-management",
      element: <ProductManagement />,
    },
    {
      id: 1081,
      enabled: true,
      path: "/product-management/addNewProduct",
      element: <AddNewProduct />,
    },
    {
      id: 1082,
      enabled: true,
      path: "/product-management/editSelectedProduct/:productId",
      element: <EditSelectedProduct />,
    },
       {
      id: 10893,
      enabled: true,
      path: "/product-management/viewSelectedProduct/:productId",
      element: <ViewSelectedProduct />,
    },
    // ----user Management Part
    {
      id: 109,
      enabled: true,
      path: "/user-management",
      element: <UserManagement />,
    },
    {
      id: 110,
      enabled: true,
      path: "/user-management/details/:userId",
      element: <UserManagementDetails />,
    },
    {
      id: 1101,
      enabled: true,
      path: "/user-management/edit/:userId",
      element: <EditUserManagement />,
    },



    {
      id: 201,
      enabled: true,
      path: "/Manage-delivery-slots-fees",
      element: <ManageDelivery />,
    },
    {
      id: 202,
      enabled: true,
      path: "/coin-management",
      element: <CoinManagement />,
    },
    {
      id: 203,
      enabled: true,
      path: "/promocode-management",
      element: <PromoCodeManagement />,
    },
    {
      id: 203,
      enabled: true,
      path: "/promocode-management/add",
      element: <AddPromoCode />,
    },
    {
      id: 203,
      enabled: true,
      path: "/promocode-management/edit/:id",
      element: <UpdatePromoCode />,
    },
    {
      id: 203,
      enabled: true,
      path: "/offer-management",
      element: <OfferList />,
    },
    {
      id: 203,
      enabled: true,
      path: "/offer-management/add",
      element: <AddOffer />,
    },
    {
      id: 204,
      enabled: true,
      path: "/offer-management/update/:offerId",
      element: <UpdateOffer />,
    },

    // --------order-management---------------
    {
      id: 2003,
      enabled: true,
      path: "/order-management",
      element: <OrderManagement />,
    },
    {
      id: 2004,
      enabled: true,
      path: "/order-management/order-details/:orderId",
      element: <OrderDetails />,
    },
    // --------sub-admin-------------
    {
      id: 3004,
      enabled: true,
      path: "/sub-admin-management",
      element: <SubAdminList />,
    },
    // --------customer-support--------------
    {
      id: 3004,
      enabled: true,
      path: "/customer-support",
      element: <SupportList />,
    },
    // User
    // {
    //   id: 102,
    //   enabled: true,
    //   element: <UserManagement />,
    //   path: "/user-management",
    // },
    // {
    //   id: 106,
    //   enabled: true,
    //   element: <UserDetail />,
    //   path: "/user-management/user-detail/:userId",
    // },

    // // Survey Category
    // {
    //   id: 103,
    //   enabled: true,
    //   element: <CategoryManagement />,
    //   path: "/survey-category",
    // },

    // // Faq
    // {
    //   id: 104,
    //   enabled: true,
    //   element: <FAQManagement />,
    //   path: "/faq-management",
    // },

    // //CMS
    {
      id: 105,
      enabled: true,
      element: <ContentManagement />,
      path: "/content-management",
    },

    {
      id: 1010,
      enabled: true,
      element: <NotificationList />,
      path: "/notification",
    },
    {
      id: 1011,
      enabled: true,
      element: <CreateNotification />,
      path: "/notification/create",
    },
    {
      id: 2011,
      enabled: true,
      element: <TransactionList />,
      path: "/transaction-management",
    },
    {
      id: 2011,
      enabled: true,
      element: <PaymentList />,
      path: "/payment-management",
    },
    {
      id: 2022,
      enabled: true,
      element: <List />,
      path: "/out-of-stock",
    },
    {
      id: 2023,
      enabled: true,
      element: <HighStock />,
      path: "/high-stock",
    },

     {
      id: 2024,
      enabled: true,
      path: "/sub-Category-Management/Add-sub-Category",
      element: <AddSubCat />,
    },
     {
      id: 2024,
      enabled: true,
      path: "/sub-Category-Management/Edit-sub-Category/:id",
      element: <EditSubCat />,
    },
    // {
    //   id: 1012,
    //   enabled: true,
    //   element: <SubAdminList />,
    //   path: "/sub-admin",
    // },
    // {
    //   id: 1013,
    //   enabled: true,
    //   element: <UpsertSubAdmin />,
    //   path: "/sub-admin/create",
    // },
    // {
    //   id: 1014,
    //   enabled: true,
    //   element: <UpsertSubAdmin />,
    //   path: "/sub-admin/detail/:adminId",
    // },
    // {
    //   id: 1015,
    //   enabled: true,
    //   element: <Subscription />,
    //   path: "/subscription",
    // },
    // {
    //   id: 1016,
    //   enabled: true,
    //   element: <ManageWallet />,
    //   path: "/wallet",
    // },
    // {
    //   id: 1017,
    //   enabled: true,
    //   element: <WalletDetail />,
    //   path: "/wallet/details/:walletId",
    // },
    // {
    //   id: 1018,
    //   enabled: true,
    //   element: <ReportsAnalytics />,
    //   path: "/reports",
    // },
  ].filter((data) => data.enabled);
  return allRoutes;
};
